import cx from "classnames";

import { useHaptics } from "../../modules/haptics/useHaptics/useHaptics";

interface CheckboxProps {
  checked?: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  subtitle?: string;
  disabled?: boolean;
  invalid?: boolean;
  textStyle?: "text-body2" | "text-bold2" | "text-body3";
}

export const Checkbox = ({
  label,
  subtitle,
  checked,
  onChange,
  disabled = false,
  invalid = false,
  textStyle = "text-body2",
}: CheckboxProps) => {
  const { triggerHaptic } = useHaptics();
  return (
    <div className="flex cursor-pointer items-center">
      <input
        type="checkbox"
        aria-invalid={invalid}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          void triggerHaptic("checkbox").catch(() => undefined);
          onChange?.(e.target.checked);
        }}
        className={cx(
          "m-2.5 h-6 w-6 cursor-pointer rounded border border-solid border-dark-grey bg-white text-brand-color ring-0 ring-transparent focus:ring-0 focus:ring-transparent aria-invalid:ring-1 aria-invalid:ring-red aria-invalid:placeholder:text-red",
          disabled && "cursor-not-allowed opacity-30"
        )}
      />
      <div className="ml-1.5 flex flex-col gap-0.5 text-left">
        {label && (
          <div
            className={cx(
              `${textStyle} `,
              invalid && "text-red",
              disabled ? "text-secondary" : "text-primary"
            )}
          >
            {label}
          </div>
        )}
        {subtitle && (
          <div className="text-body2 text-secondary">{subtitle}</div>
        )}
      </div>
    </div>
  );
};
